<script setup lang="ts">
import BaseAddress from '@/components/molecules/BaseAddress.vue';
import ConnectWalletBtn from '@/components/atoms/ConnectWalletBtn.vue';
import { useSolBalance } from '@/helpers/solana/useSolBalance';
import { useWallet } from 'solana-wallets-vue';

const { execute: refreshSolBalance, isFetching } = useSolBalance();
const { connected, publicKey, disconnect } = useWallet();
</script>

<template>
  <div v-if="connected && publicKey" class="flex flex-row gap-4">
    <div class="flex-1 flex gap-2 flex-row items-center">
      <v-icon class="opacity-60" size="small">mdi-wallet-outline</v-icon>
      <base-address
        :address="publicKey.toString()"
        click-to-copy
        force-short
      ></base-address>
    </div>
    <div class="flex flex-row gap-2">
      <v-btn @click="refreshSolBalance" :disabled="isFetching">
        <v-icon :class="{ 'animate-spin': isFetching }">mdi-refresh</v-icon>
      </v-btn>
      <v-btn @click="disconnect">
        <v-icon size="small">mdi-logout</v-icon>
      </v-btn>
    </div>
  </div>

  <div v-else class="flex justify-end">
    <ConnectWalletBtn />
  </div>
</template>
